import { render } from "./DiagnosisGapTypeBand.vue?vue&type=template&id=42e7ffef"
import script from "./DiagnosisGapTypeBand.vue?vue&type=script&lang=js"
export * from "./DiagnosisGapTypeBand.vue?vue&type=script&lang=js"

import "./DiagnosisGapTypeBand.vue?vue&type=style&index=0&id=42e7ffef&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__